import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Urls from './Urls';


// Define the async thunk for fetching all doctors
export const fetchDoctors = createAsyncThunk(
    'hrdoctors/fetchDoctors',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(Urls.authurl + 'Auth/GetAllDoctors');
            console.log(response.data)
            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const onboardDoctor = createAsyncThunk(
    'hrdoctors/onboardDoctor',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await axios.post(Urls.authurl + 'Auth/Login',data);

            const newDoctor = response.data;
            
            dispatch(addDoctor({
                ...newDoctor,
                KycStatus: newDoctor.KycStatus || 'Unverified', 
                dateJoined: new Date().toISOString().split('T')[0] 
            }));

            return newDoctor;
        } catch (error) {
            const errorMessage = error.response?.data || error.message || 'Failed to onboard doctor.';
            return rejectWithValue(errorMessage);
        }
    }
);


const initialState = {
    doctors: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed' for general fetch
    error: null,
    onboardingStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed' for the add doctor operation
    onboardingError: null,
};

const HrdoctorsSlice = createSlice({
    name: 'hrdoctors',
    initialState,
    reducers: {
        addDoctor: (state, action) => {
            state.doctors.push(action.payload);
        },
        updateDoctorKycStatus: (state, action) => {
            const { id, kycStatus } = action.payload;
            const existingDoctor = state.doctors.find(doctor => doctor.Id === id);
            if (existingDoctor) {
                existingDoctor.KycStatus = kycStatus;
            }
        },
         clearOnboardingStatus: (state) => {
            state.onboardingStatus = 'idle';
            state.onboardingError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDoctors.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchDoctors.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.doctors = action.payload.map(doc => ({
                    ...doc,
                    dateJoined: 'N/A' 
                }));
            })
            .addCase(fetchDoctors.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Failed to fetch doctors';
            })
            .addCase(onboardDoctor.pending, (state) => {
                state.onboardingStatus = 'loading';
                state.onboardingError = null;
            })
            .addCase(onboardDoctor.fulfilled, (state) => {
                state.onboardingStatus = 'succeeded';
            })
            .addCase(onboardDoctor.rejected, (state, action) => {
                state.onboardingStatus = 'failed';
                state.onboardingError = action.payload || 'Onboarding failed.';
            });
    },
});

export const { addDoctor, updateDoctorKycStatus, clearOnboardingStatus } = HrdoctorsSlice.actions;

export const selectAllDoctors = (state) => state.hrdoctors.doctors;
export const getDoctorsStatus = (state) => state.hrdoctors.status;
export const getDoctorsError = (state) => state.hrdoctors.error;

export const getOnboardingStatus = (state) => state.hrdoctors.onboardingStatus;
export const getOnboardingError = (state) => state.hrdoctors.onboardingError;

export default HrdoctorsSlice.reducer;